import { TicketOrigin } from 'helpers/Enums';

interface IProps {
    value?: TicketOrigin
}

let TicketSource = ({ value }: IProps) => {
    switch (value) {
        case TicketOrigin.Customer: return (<span>Cliente</span>);
        case TicketOrigin.Email: return (<span>Email</span>);
        case TicketOrigin.MySimecApp: return (<span>App MySimec</span>);
        case TicketOrigin.Simec: return (<span>Simec</span>);

        default: return (<span></span>)
    }
}

export default TicketSource;